import { jsx as t } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import o from "./CheckboxComponent.js";
var r = e(function (e, r) {
  return t(o, Object.assign({
    name: "",
    value: ""
  }, e, {
    inputRef: r
  }));
});
export { r as default };